// keycloakUtils.js
import { useKeycloak } from '@react-keycloak/web';

export const useAppKeycloak = () => {
  const { initialized, keycloak } = useKeycloak();
  return { initialized, keycloak };
};
